module.exports = __webpack_public_path__ + "img/selected4-min.8b437218.png";